module.exports = __webpack_public_path__ + "img/simiconnect.9e71830c.png";